import React, { useEffect, useRef, useState } from "react";

const RecipientCard = ({ recipient, busy = false, onRemove }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return undefined;

    const onDocumentClick = (event) => {
      if (!cardRef.current?.contains(event.target)) setMenuOpen(false);
    };

    document.addEventListener("mousedown", onDocumentClick);

    return () => document.removeEventListener("mousedown", onDocumentClick);
  }, [menuOpen]);

  const openMenu = (event) => {
    event.preventDefault();
    setMenuOpen(true);
  };

  return (
    <article className="fin-account" ref={cardRef} onContextMenu={openMenu}>
      <header className="fin-account-head">
        <span className="fin-account-provider">{recipient.providerName}</span>

        <button
          type="button"
          className="fin-account-more"
          aria-label="Account options"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <svg viewBox="0 0 20 20" aria-hidden="true">
            <circle cx="4" cy="10" r="1.5" />
            <circle cx="10" cy="10" r="1.5" />
            <circle cx="16" cy="10" r="1.5" />
          </svg>
        </button>
      </header>

      <p className="fin-account-number">{recipient.maskedAccountNumber}</p>
      <p className="fin-account-name">{recipient.accountName}</p>

      {recipient.isDefault && <span className="fin-pill fin-pill-brand">Default</span>}

      {menuOpen && (
        <div className="fin-account-menu" role="menu">
          <button
            type="button"
            role="menuitem"
            className="fin-account-menu-item is-danger"
            disabled={busy}
            onClick={() => {
              setMenuOpen(false);
              onRemove(recipient);
            }}
          >
            {busy ? "Removing…" : "Remove Account"}
          </button>
        </div>
      )}
    </article>
  );
};

export default RecipientCard;
